import { store } from "src/internal/WithProviders/WithProviders";
import { internalLogout } from "src/internal/actions/authActions";
import { ErrorMessage } from "src/external/types/errors";
import { tokenKey } from "src/internal/types/authentication";
import * as Cookies from "js-cookie";

export const handleApiError = (error: any): never => {
  if (error.response && error.response.data && error.response.data.message) {
    throw error.response.data;
  }

  if (error.response && error.response.status === 401) {
    store.dispatch(internalLogout());

    const error: ErrorMessage = {
      visible: true,
      message: "Your session has expired.  Please login again."
    };
    sessionStorage.removeItem(tokenKey);
    Cookies.remove(tokenKey);
    throw error;
  }

  throw error;
};
